




import {Component, Ref, Vue} from 'vue-property-decorator'
import Tariff from '../Tarification/Tariff.vue';
import {TarificationTypes, TarificationTransports} from "@/store/tarification/types";

Component.registerHooks([
  'beforeRouteLeave',
])
@Component({components: {Tariff}})
export default class PushPartnerTariff extends Vue{
  @Ref('tariff') tariff: any;
  private partnerType: TarificationTypes = TarificationTypes.PARTNER
  private tarificationTransport: TarificationTransports = TarificationTransports.PUSH

  beforeRouteLeave(to:any, from:any, next:any) {
    this.tariff.beforeLeave(to,from,next)
  }
}
